import React from "react";
import Footer from "../components/Footer";
import "./About.css";

const About = () => {
  return (
    <div className="about-page">

      {/* Our Story Section */}
      <section className="our-story-section">
        <div className="our-story-overlay">
          <div className="our-story-box">
            <h2 className="our-story-heading">OUR STORY</h2>
            <p className="our-story-text">
              Founded in 2013, our company was established with a clear mission:
              to help people understand the true importance of food and real
              nutrition. We believe that informed choices about what we eat can
              transform health and wellbeing. Each product reflects our
              commitment to quality, authenticity, and natural ingredients.
              Rooted in the philosophy of restoring tradition and empowering
              wellness, we strive to reconnect people with natural and
              time-honoured approaches to nutrition. Through our work, we
              continue to promote a deeper connection between nutrition, science,
              and everyday health.
            </p>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section className="our-team-section">
        <img
          src="https://storage.googleapis.com/rasai-nutrie-assets/sections/ourteam.jpg"
          alt="Our Team"
          className="our-team-bg"
        />
        <div className="our-team-box">
          <h2 className="our-team-heading">OUR TEAM</h2>
          <p className="our-team-text">
            Our team brings together individuals with diverse expertise in
            nutrition, biochemistry, biotechnology, and quality assurance.
            United by a shared commitment to promoting real nutrition and
            natural wellness, our professionals work collaboratively to
            research, develop, and deliver products that reflect both
            scientific understanding and traditional knowledge. From
            formulation to production and customer support, every member of
            our team contributes to maintaining the quality, authenticity, and
            integrity that define our work.
          </p>
        </div>
      </section>

      {/* Our Research Section */}
      <section className="our-research-section">
        <div className="our-research-overlay">
          <div className="our-research-box">
            <h2 className="our-research-heading">OUR RESEARCH</h2>
            <h3 className="our-research-subheading">Research &amp; Scientific Framework</h3>
            <p className="our-research-text">
              Our research focuses on understanding the biochemical relationship
              between food, metabolism, and long-term health. We study how
              nutrients are digested, absorbed, and metabolized, and how gut
              microbiota influence metabolic pathways. Special emphasis is
              placed on the role of phospholipids, liver function, and gut
              health in maintaining systemic balance. By combining traditional
              nutritional knowledge with modern biochemical insights, we develop
              formulations that support healthy metabolic processes. Our goal is
              to translate complex science into practical, food-based solutions
              for everyday wellbeing.
            </p>
          </div>
        </div>
      </section>

      {/* Who Is RASAI Nutrie Built For */}
      <section className="who-section">
        <div className="who-image-col">
          <img
            src="https://storage.googleapis.com/rasai-nutrie-assets/sections/who.png"
            alt="Who is RASAI Nutrie built for"
            className="who-image"
          />
        </div>
        <div className="who-text-col">
          <h2 className="who-heading">WHO IS RASAI NUTRIE<br />BUILT FOR</h2>
          <p className="who-text">
            Designed for people from all walks of life who wish to improve
            their relationship with food and nutrition. While it is designed
            for everyone, it particularly aims to support individuals
            experiencing poor health, nutritional deficiencies, or imbalanced
            diets. Through carefully developed tisanes and food products, we
            seek to promote better metabolic health and overall wellbeing.
          </p>
        </div>
      </section>

      {/* What We Stand For */}
      <section className="stand-section">
        <div className="stand-text-col">
          <h2 className="stand-heading">WHAT WE STAND FOR</h2>
          <p className="stand-text">
            We stand for real nutrition, scientific integrity, and the
            restoration of traditional food wisdom. Our commitment is to
            develop natural, thoughtfully formulated products that support
            metabolic health and everyday wellbeing.
          </p>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="vision-mission-section">
        <div className="vision-mission-overlay">
          <div className="vm-col">
            <h2 className="vm-heading">OUR VISION</h2>
            <p className="vm-body">
              To become a renowned organization that bridges traditional food
              wisdom with modern science, empowering lifelong metabolic health
              through nutrition.
            </p>
          </div>
          <div className="vm-divider" />
          <div className="vm-col">
            <h2 className="vm-heading">OUR MISSION</h2>
            <p className="vm-body">
              To develop thoughtfully formulated products that support holistic
              wellbeing by focusing on natural ingredients, scientific insight,
              and traditional nutritional knowledge.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Video Section */}
      <section className="stats-section">
        <video
          className="stats-video"
          src="https://storage.googleapis.com/rasai-nutrie-assets/videos/about-stats.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="stats-overlay">
          <div className="stat-item">
            <span className="stat-number">1000+</span>
            <span className="stat-label">CLIENTS</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">FORMULATIONS</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">300+</span>
            <span className="stat-label">PRODUCTS</span>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
